<!DOCTYPE html>
<div class="card-wrapper">
  <div class="close" (click)="closeBox()"><img src="../../../../assets/icon/x.png"></div>
  <div class="header-wrapper">
    <img class="hero-img" src="../../../../assets/images/14daylogo.png" alt="hero-img" />
    <p class="above-title">{{'win_more_promise.exclusive'| translate}}</p>
    <h2 class="title" [innerHTML]="'win_more_promise.wmp_works'| translate"></h2>
  </div>
  <div class="faq-wrapper">
    <div class="card-wrapper-progress">
      <div class="topbar">
        <div class="left">{{'win_more_promise.your_almost'| translate}}</div>
        <div class="right">
          <img class="gray-clock" src="../../../../assets/icon/mingrayclock.svg" alt="gray-clock" />
          @if (days >=0 && days !== -1) {
            <span id="days">{{days}}d</span>
            } &nbsp;
            @if (hours >= 0 && hours !== -1) {
              <span id="hours"> {{hours}}hr</span>
              } &nbsp;
            </div>
          </div>
          <div class="card">
            <div class="row-bar">
              <div class="title">{{'win_more_promise.together'| translate}}</div>
              <div class="progress">
                <div class="progress-bar">
              <div class="fill" [ngStyle]="{
            'width.%': ( getProgressBar(false) >= 0 && getProgressBar(false) <= 100 ) ? getProgressBar(false) : 0,
            background: 'linear-gradient(180deg, #17D9D2 0%, #1FD583 100%)'
          }"></div>
                </div>
              </div>
              <div class="nu">{{winMorePromiseDetails?.together_win_count ?? 0}}</div>
            </div>
            <div class="row-bar">
              <div class="title">{{'win_more_promise.alone'| translate}}</div>
              <div class="progress">
                <div class="progress-bar">
              <div class="fill" [ngStyle]="{
          'width.%': ( getProgressBar(true) >= 0 && getProgressBar(true) <= 100 ) ? getProgressBar(true) : 0,
          background: 'linear-gradient(180deg, #17D9D2 0%, #1FD583 100%)'
        }"></div>

                </div>
              </div>
              <div class="nu"> {{winMorePromiseDetails?.alone_win_count ? winMorePromiseDetails?.alone_win_count : 0}}</div>
            </div>
          </div>
        </div>

        <h4>{{'win_more_promise.faq'| translate}}</h4>
        <div class="help-accordion">
          <mat-accordion>
            <!-- FAQ 1 -->
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{'win_more_promise.que_one'| translate}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>
                {{'win_more_promise.our_promise'| translate}}
                <br>{{'win_more_promise.when_you_play'| translate}}
                  <br> {{'win_more_promise.With_lotto'| translate}}
                    <br>{{'win_more_promise.you_will'| translate}}
                      <br>{{'win_more_promise.once_the'| translate}}
                      </p>
                    </mat-expansion-panel>
                    <!-- FAQ 2 -->
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{'win_more_promise.que_five'| translate}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p>{{'win_more_promise.more_than_once'| translate}}</p>
                    </mat-expansion-panel>
                    <!-- FAQ 3 -->
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{'win_more_promise.que_four'| translate}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p>{{'win_more_promise.terms_conditions'| translate}}
                        <br> <br> {{'win_more_promise.cash_winnings'| translate}}
                        <br> <br> {{'win_more_promise.we_will'| translate}}
                        <br> <br> {{'win_more_promise.winnings'| translate}}
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>

                <div class="btn-wrapper">
                  <ion-button expand="block" color="secondary" class="capsule-btn common-margin syndicate-btn" (click)="closeBox()">
                    {{'win_more_promise.got_it'| translate}}
                  </ion-button>

                </div>
              </div>
